import React, { Component } from "react";
import s from "./styles.scss";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ConfiguracionMetasTable from "./ConfiguracionMetas.table";
import { ConfiguracionMetasStore } from "../../../containers/comisionesMembresiaConfiguracion/configuracionMetas/ConfiguracionMetas.store";
import { ConfiguracionMetasDispatcher } from "../../../containers/comisionesMembresiaConfiguracion/configuracionMetas/ConfiguracionMetas.dispatcher";
import { ProcesoResultado } from "../../../../types/MembresiaMetaCarga";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import { downloadMetasArchivo } from "../../../actions/comisionMembresia";

interface Props extends ConfiguracionMetasStore, ConfiguracionMetasDispatcher {}

interface State {
  downloading: boolean;
  selectedFile: File | null;
}

@Styled(s)
export default class ConfiguracionMetasComponent extends Component<
  Props,
  State
> {
  state = {
    downloading: false,
    selectedFile: null
  };

  onFileChange = evt => {
    if (evt.target.files && evt.target.files.length > 0) {
      this.props.clearMetas();
      this.setState({ selectedFile: evt.target.files[0] });
    }
  };

  onUpload = async (confirmar: boolean) => {
    if (!this.state.selectedFile) {
      return;
    }

    const formData = new FormData();
    formData.append("file", this.state.selectedFile);

    const preview = await this.props.postCargaMetas(formData, confirmar);

    if (preview.fulfilled) {
      const carga = preview.cargaMembresiaMeta;

      if (carga.resultado != ProcesoResultado.ERROR) {
        successNotification(
          confirmar
            ? "Metas cargadas correctamente"
            : "Archivo validado correctamente"
        );

        if (confirmar) {
          this.setState({ selectedFile: null });
        }
      } else {
        errorNotification(
          confirmar
            ? "El archivo contenía errores"
            : "Verifique el archivo por favor"
        );
      }
    } else {
      errorNotification(
        preview.postingCargaMembresiaMetaError ||
          "Error en la carga del archivo"
      );
    }
  };

  onDiscardFile = () => {
    this.setState({ selectedFile: null });
    this.props.clearMetas();
  };

  onLoadCurrentMetas = async () => {
    const preview = await this.props.getMetasActuales();

    if (preview.fulfilled) {
      successNotification("Metas actuales cargadas");
    } else {
      errorNotification(
        preview.gettingComisionMembresiaMetasActualesError ||
          "Error al cargar las metas actuales"
      );
    }
  };

  isWaiting = () => {
    return (
      this.state.downloading ||
      this.props.gettingComisionMembresiaMetas ||
      this.props.gettingComisionMembresiaMetasActuales ||
      this.props.postingCargaMembresiaMeta
    );
  };

  spinnerOnWait = (label: string) => {
    return this.isWaiting() ? (
      <FontAwesomeIcon icon={faSpinner} pulse />
    ) : (
      label
    );
  };

  render() {
    const {
      cargaMembresiaMeta,
      comisionMembresiaMetas,
      comisionMembresiaMetasActuales
    } = this.props;
    const { selectedFile } = this.state;
    const hasError = cargaMembresiaMeta
      ? cargaMembresiaMeta.resultado == ProcesoResultado.ERROR
      : false;
    const metasRegionales = cargaMembresiaMeta
      ? cargaMembresiaMeta.metasRegionales || []
      : comisionMembresiaMetasActuales
      ? comisionMembresiaMetasActuales.metasRegionales || []
      : comisionMembresiaMetas
      ? comisionMembresiaMetas.metasRegionales || []
      : [];

    return (
      <>
        <div className="container">
          <div className="row mt-3">
            {!selectedFile && (
              <>
                <div className="col-md-3">
                  <Button
                    className={`${s.primaryButton}`}
                    type="button"
                    size="sm"
                    block
                    onClick={this.onLoadCurrentMetas}
                    disabled={this.isWaiting()}
                  >
                    {this.spinnerOnWait("Ver metas actuales")}
                  </Button>
                </div>
                <div className="col-md-3">
                  <Button
                    type="button"
                    className={`${s.primaryButton} ${s.fileButton}`}
                    size="sm"
                    block
                    disabled={this.isWaiting()}
                    onClick={e => {
                      if (this.isWaiting()) {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                    }}
                  >
                    {this.spinnerOnWait("Seleccionar archivo")}
                    <input
                      className={s.inputFile}
                      type="file"
                      accept=".xlsx,.xls"
                      title=""
                      disabled={this.isWaiting()}
                      onChange={this.onFileChange}
                    />
                  </Button>
                </div>
              </>
            )}

            {selectedFile && (
              <>
                <div className="col-md-3">
                  <Button
                    color="danger"
                    type="button"
                    size="sm"
                    block
                    onClick={this.onDiscardFile}
                    disabled={this.isWaiting()}
                  >
                    Descartar archivo
                  </Button>
                  <div className="mt-2">
                    <small className="text-muted">
                      <strong>Archivo:</strong> {selectedFile.name}
                    </small>
                  </div>
                </div>
                <div className="col-md-3">
                  {(!cargaMembresiaMeta || hasError) && (
                    <Button
                      className={`${s.primaryButton}`}
                      type="button"
                      size="sm"
                      block
                      onClick={() => this.onUpload(false)}
                      disabled={this.isWaiting()}
                    >
                      {this.spinnerOnWait("Verificar archivo")}
                    </Button>
                  )}
                  {cargaMembresiaMeta && !hasError && (
                    <Button
                      className={`${s.primaryButton}`}
                      type="button"
                      size="sm"
                      block
                      onClick={() => this.onUpload(true)}
                      disabled={this.isWaiting()}
                    >
                      {this.spinnerOnWait("Cargar metas")}
                    </Button>
                  )}
                </div>
              </>
            )}
          </div>

          {metasRegionales.length > 0 && (
            <div className="mt-4">
              <ConfiguracionMetasTable
                metasRegionales={metasRegionales}
                esMetasActuales={
                  !!comisionMembresiaMetasActuales && !cargaMembresiaMeta
                }
                nombreArchivo={
                  comisionMembresiaMetasActuales &&
                  comisionMembresiaMetasActuales.nombreArchivo
                }
                fechaCarga={
                  comisionMembresiaMetasActuales &&
                  comisionMembresiaMetasActuales.fechaCarga
                }
                resultado={cargaMembresiaMeta && cargaMembresiaMeta.resultado}
                mensaje={cargaMembresiaMeta && cargaMembresiaMeta.mensaje}
              />
            </div>
          )}
        </div>
      </>
    );
  }
}
